import uniqid from 'uniqid'
import { apps } from '../../portfolio'
import AppContainer from '../AppContainer/AppContainer'
import './Apps.css'

const Apps = () => {
  if (!apps.length) return null

  return (
    <section id='apps' className='section apps'>
      <h2 className='section__title'>Mobile Apps</h2>

      <div className='apps__grid'>
        {apps.map((app) => (
          <AppContainer key={uniqid()} app={app} />
        ))}
      </div>
    </section>
  )
}

export default Apps
